import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import API from "service/API";
import { setPortfolio } from "store/actionReducers/PortfolioStore";

const usePortfolio = () => {
  const dispatch = useDispatch();

  const fetchPortfolio = useCallback(async (stock) => {
    const res = await API.Portfolio.GetPortfolioStock(stock)
    if (res?.code === '0') {
      dispatch(setPortfolio(res?.data))
    }
  }, [])

  return { fetchPortfolio }
}

export default usePortfolio